import React from "react"

export const FloatingActionBarElement: React.FunctionComponent<
    IFloatingActionBarElementProps
> = props => {
    return (
        <div
            className={`
                fixed bottom-[24px] horizontal-center z-20
                flex items-center flex-wrap justify-center
                bg-brand-white rounded-[100px]
                w-max md:w-auto max-w-[90vw]
                pl-[32px] py-[12px] pr-[12px] md:px-[12px]
                border border-solid border-brand-vibrantPurple
                ${props.className ?? ""}
            `}
        >
            {props.children}
        </div>
    )
}

interface IFloatingActionBarElementProps {
    children?: React.ReactNode
    className?: string
}
